<div class="dynamic-content" [appStoryblok]="_editable" [ngStyle]="{'background-color': background_color && !transparent_background ? background_color.color : 'transparent', 'color': text_color?.color, 'grid-template-columns': 'repeat(' + max_blocks_per_row + ', 1fr)', 'row-gap': row_gap + 'px', 'column-gap': column_gap + 'px', 'border': border}">
  @for (blok of text; track blok) {
    <div class="col-12" [ngStyle]="blok.col_span ? {'grid-column': 'span ' + blok.col_span + ' / span ' + blok.col_span} : null">
      @if (blok.component) {
        <ndc-dynamic
          [ndcDynamicComponent]="components[blok.component]"
          [ndcDynamicInputs]="blok"
          >
        </ndc-dynamic>
      }
    </div>
  }
</div>
